import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const isAuthCall = cfg.url && cfg.url.startsWith("/auth/");
    if (err.response?.status === 401 && !cfg._retry && !isAuthCall) {
      cfg._retry = true;
      try {
        await api.post("/auth/refresh");
        return api(cfg);
      } catch (e) {
        // refresh failed
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
